// Recovered compiled webpack factory 16612. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  const noop = () => {},
    subscribe = () => noop,
    decline = async () => false,
    state = { policy: { tier: "off", banner: false }, loading: false },
    snapshot = () => state;
  n.d(t, {
    B1: () => subscribe,
    Cp: () => decline,
    FC: () => noop,
    Md: () => noop,
    N1: () => decline,
    PS: () => snapshot,
    QA: () => noop,
    VD: () => subscribe,
    oe: () => noop,
    u4: () => noop,
  });
}
